import { put, select, takeLatest, all } from 'redux-saga/effects';
import { notify } from '@mrlannigan/reapop';
import { sagaError } from 'helpers/handleGenericSagaError';
import apiAuthCall from 'helpers/apiAuthCall';

import { actions, realValueFetched } from './duck';
import { realValueEndpoint } from './selectors';

export function* fetchRealValue(api, action) {
    try {
        const result = yield apiAuthCall(
            action.getState(),
            [api, api.request],
            {
                method: 'get',
                url: yield select(realValueEndpoint, action.payload)
            }
        );

        yield put(realValueFetched(result.data));
    } catch (err) {
        yield put(notify({
            id: action.payload.transactionId,
            ...sagaError(err)
        }));
    }
}


export default function* realValueSagas({ api }) {
    yield all([
        takeLatest(actions.FETCH, fetchRealValue, api)
    ]);
}



// WEBPACK FOOTER //
// ./src/services/realValue/saga.js